module.exports = __webpack_public_path__ + "static/media/icon-tips.4862b304.svg";